import { render } from "./PrivacyTerms.vue?vue&type=template&id=62075371"
import script from "./PrivacyTerms.vue?vue&type=script&lang=js"
export * from "./PrivacyTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__